import {
  CalloutBody,
  CalloutIcon,
  CalloutRoot,
  Stack,
  Text,
} from '@global-ecom/nitro-uds/elements';
import React from 'react';

type ModelMeasurementCalloutPropsType = {
  measurementText: string;
};

export const ModelMeasurementCallout: React.FC<
  ModelMeasurementCalloutPropsType
> = ({ measurementText }) => {
  return (
    <CalloutRoot
      bleed
      fill
      outline
      inset="sm"
      variant="muted"
      className="bg-gray-100 flex items-center"
      data-test-id="model-measurement-text"
    >
      <CalloutIcon icon="info" />
      <CalloutBody>
        {measurementText?.split('\n').map(text => (
          <Stack key={text}>
            <Text>{text}</Text>
          </Stack>
        ))}
      </CalloutBody>
    </CalloutRoot>
  );
};
